// 旧ルーブリック（C1〜C16）のカテゴリ名 → 番号。旧形式の採点詳細だけで使う。
export const CATEGORY_TO_CID: Record<string, string> = {
  挨拶: "C0",
  コミュニケーション: "C0",
  "主訴・現在直面している問題": "C1",
  "歯科受療行動・過去の経験": "C2",
  "セルフケア行動（ブラッシング・清掃用具）": "C3",
  "飲食習慣・嗜好品摂取行動": "C5",
  "喫煙・受動喫煙の状態": "C6",
  "全身疾患・既往歴の把握": "C7",
  服薬状況と医師指示の理解: "C9",
  医科歯科連携と受診状況: "C10",
  "生活リズム・睡眠・ストレス": "C11",
  "予防処置・専門的ケアの経験": "C13",
  要配慮者の口腔管理: "C14",
  "義歯・インプラント・補綴物の使用状況": "C15",
};

type ItemScoreLike = { category?: unknown; v31?: { categoryId?: unknown; categoryName?: unknown } | null };

/**
 * 対象外カテゴリの番号（patientNaCategories）から、除外するカテゴリ名を決める。
 * 新しい CSV（SRC_Cn）では同じ名前が旧ルーブリックと別の番号になる（例: 喫煙は旧C6・新C14）ため、
 * 採点詳細に新形式の項目があれば、その v31.categoryId / categoryName で対応を作る。
 */
export function naCategoryNamesFor(
  patientNaCategories: Iterable<string>,
  itemScores: readonly ItemScoreLike[] | null | undefined,
): Set<string> {
  const naIds = new Set(patientNaCategories);
  const modern = new Map<string, string>();
  let hasModernItems = false;
  for (const item of itemScores ?? []) {
    const categoryId = item?.v31?.categoryId;
    const categoryName = item?.v31?.categoryName ?? item?.category;
    if (typeof categoryId !== "string" || typeof categoryName !== "string" || !categoryName) continue;
    if (categoryId.startsWith("SRC_C")) hasModernItems = true;
    modern.set(categoryName, categoryId.replace(/^SRC_/, ""));
  }
  const entries = hasModernItems ? Array.from(modern.entries()) : Object.entries(CATEGORY_TO_CID);
  const names = new Set<string>();
  for (const [name, cid] of entries) {
    if (naIds.has(cid)) names.add(name);
  }
  return names;
}
